module.exports = __webpack_public_path__ + "static/media/logos-print-per-mano.9cb8ce8e.jpg";